module.exports = __webpack_public_path__ + "img/dropdown-arrow.b02a8f94.svg";